module.exports = __webpack_public_path__ + "static/media/grab_alc_singha_bottle320.e908b747.jpg";